import { FeedbackMessage } from '@sendible/design-system/src/components/molecules/ComposeDropDown';

interface ValidationErrorSortedType extends FeedbackMessage {
  forTabs: string[];
}

export const validationErrorSorted: ValidationErrorSortedType[] = [
  // IMPORTANT: When adding new validations, mind the order: danger > warning.
  {
    message: 'DurationOutOfRange',
    type: 'danger',
    forTabs: ['facebook', 'instagram'],
  },
  {
    message: 'HeightOutOfRange',
    type: 'danger',
    forTabs: ['twitter', 'instagram', 'linkedin'],
  },
  {
    message: 'MaxSizeExceeded',
    type: 'danger',
    forTabs: ['facebook', 'twitter', 'instagram', 'googlemybusinesslocation'],
  },
  {
    message: 'MinimumWidthNotMet',
    type: 'danger',
    forTabs: ['facebook'],
  },
  {
    message: 'MinimumHeightNotMet',
    type: 'danger',
    forTabs: ['facebook'],
  },
  {
    message: 'UnsupportedMediaType',
    type: 'danger',
    forTabs: ['facebook', 'twitter', 'instagram', 'googlemybusinesslocation', 'linkedin'],
  },
  {
    message: 'WidthOutOfRange',
    type: 'danger',
    forTabs: ['twitter', 'instagram', 'linkedin'],
  },
  {
    message: 'AspectRatioOutOfRange',
    type: 'warning',
    forTabs: ['facebook', 'instagram', 'linkedin'],
  },
  {
    message: 'MaxSizeExceeded',
    type: 'warning',
    forTabs: ['linkedin'],
  },
];

export const networkToTabMapping: Record<string, string> = {
  facebook: 'facebook',
  googleBusiness: 'googlemybusinesslocation',
  instagram: 'instagram',
  linkedIn: 'linkedin',
  other: 'other',
  pinterest: 'pinterest',
  profileList: 'group',
  tikTok: 'tiktok',
  twitter: 'twitter',
  wordPress: 'wordpress',
  youTube: 'youtube',
};
